class HashTable {
    constructor() {
        this.values = {};
        this.length =  0;
        this.size =  0;
    }

    calculateHash(key) {
        return key.toString().length % this.size;
    }

    add(key, value) {
        const hash = this.calculateHash(key);
        if (!this.values.hasOwnProperty(hash)) {
            this.values[hash] = {};
        }
        if (!this.values[hash].hasOwnProperty(key)) {
            this.length++;
        }
        this.values[hash][key] = value;
    }

    search(key) {
        const hash = this.calculateHash(key);
        if (this.values.hasOwnProperty(hash) && this.values[hash].hasOwnProperty(key)) {
            return this.values[hash][key];
        } else {
            return null;
        }
    }
}

function initDefault(idOfDiv, defaultValue)
{
    let element = $('#' + idOfDiv);

    let staleDefaultValue =
        element.attr("default-text") &&
        element.html() &&
        element.attr("default-text") == element.html();

    element.attr("default-text", defaultValue);

    if(!element.html() || staleDefaultValue)
    {
        element.html(defaultValue);
    }
}

function getZodiacDefaultSecondaryText(zodiacName)
{
    let retval = null;
    if (zodiacName)
    {
        let zodiacNameToUpper = zodiacName.toUpperCase();

        if(zodiacNameToUpper)
        {
            if(zodiacNameToUpper.includes('ARIES'))
            {
                retval = 'Fearless, Ambitious, Optimistic';
            }
            else if (zodiacNameToUpper.includes('TAURUS'))
            {
                retval = 'Grounded, Logical, Loyal';
            }
            else if (zodiacNameToUpper.includes('GEMINI'))
            {
                retval = 'Intelligent, Perceptive, Expressive';
            }
            else if (zodiacNameToUpper.includes('CANCER'))
            {
                retval = 'Intuitive, Caring, Imaginative';
            }
            else if (zodiacNameToUpper.includes('LEO'))
            {
                retval = 'Generous, Creative, Kind';
            }
            else if (zodiacNameToUpper.includes('VIRGO'))
            {
                retval = 'Practical, Intelligent, Productive';
            }
            else if (zodiacNameToUpper.includes('LIBRA'))
            {
                retval = 'Fair, Diplomatic, Gracious';
            }
            else if (zodiacNameToUpper.includes('SCORPIO'))
            {
                retval = 'Passionate, Brave, Resourceful';
            }
            else if (zodiacNameToUpper.includes('SAGITTARIUS'))
            {
                retval = 'Honest, Optimistic, Independent';
            }
            else if (zodiacNameToUpper.includes('CAPRICORN'))
            {
                retval = 'Disciplined, Pragmatic, Ambitious';
            }
            else if (zodiacNameToUpper.includes('AQUARIUS'))
            {
                retval = 'Imaginative,  Honest, Intellectual';
            }
            else if (zodiacNameToUpper.includes('PISCES'))
            {
                retval = 'Intuitive, Wise, Affectionate';
            }
        }
    }

    return retval;
}

function getFramingOptionHashKey(framingOption)
{
    let retval = null;
    let framingOptionToUpper = framingOption ? framingOption.toUpperCase() : null;

    if(framingOptionToUpper)
    {
        if(framingOptionToUpper.includes('UNFRAMED'))
        {
            retval = 'UNFRAMED';
        }
        else if (framingOptionToUpper.includes('BLACK'))
        {
            retval = 'BLACK';
        }
        else if (framingOptionToUpper.includes('WHITE'))
        {
            retval = 'WHITE';
        }

    }

    return retval;
}

function getZodiacSignOptionHashKey(zodiacOption)
{
    let retval = null;
    let zodiacOptionToUpper = zodiacOption ? zodiacOption.toUpperCase() : null;

    if(zodiacOptionToUpper)
    {
        if(zodiacOptionToUpper.includes('ARIES'))
        {
            retval = 'ARIES';
        }
        else if (zodiacOptionToUpper.includes('TAURUS'))
        {
            retval = 'TAURUS';
        }
        else if (zodiacOptionToUpper.includes('GEMINI'))
        {
            retval = 'GEMINI';
        }
        else if (zodiacOptionToUpper.includes('CANCER'))
        {
            retval = 'CANCER';
        }
        else if (zodiacOptionToUpper.includes('LEO'))
        {
            retval = 'LEO';
        }
        else if (zodiacOptionToUpper.includes('VIRGO'))
        {
            retval = 'VIRGO';
        }
        else if (zodiacOptionToUpper.includes('LIBRA'))
        {
            retval = 'LIBRA';
        }
        else if (zodiacOptionToUpper.includes('SCORPIO'))
        {
            retval = 'SCORPIO';
        }
        else if (zodiacOptionToUpper.includes('SAGITTARIUS'))
        {
            retval = 'SAGITTARIUS';
        }
        else if (zodiacOptionToUpper.includes('CAPRICORN'))
        {
            retval = 'CAPRICORN';
        }
        else if (zodiacOptionToUpper.includes('AQUARIUS'))
        {
            retval = 'AQUARIUS';
        }
        else if (zodiacOptionToUpper.includes('PISCES'))
        {
            retval = 'PISCES';
        }
    }


    return retval;
}


function addOrd(dom) {
    if (dom == 31 || dom == 21 || dom == 1) return dom + "st";
    else if (dom == 22 || dom == 2) return dom + "nd";
    else if (dom == 23 || dom == 3) return dom + "rd";
    else return dom + "th";
}

function getMinVisibleFontSize() {
    var spanFS = document.createElement('span');
    spanFS.setAttribute('style', 'font-size:1px!important;display:none!important;');
    document.body.appendChild(spanFS);
    var minFontSize = parseInt(getComputedStyle(spanFS).fontSize);
    document.body.removeChild(spanFS);
    return minFontSize;
};

function hydrateProduct(hydratedProduct)
{
    var prodJSON;

    if(atob(hydratedProduct))
    {
        prodJSON = JSON.parse(atob(hydratedProduct));

        if(prodJSON)
        {
            if((prodJSON.PRODUCT_TYPE && prodJSON.PRODUCT_TYPE.includes('STAR')) || prodJSON.LOCATION)
            {
                if(prodJSON.LINE1)
                {
                    sessionStorage.setItem('line1', prodJSON.LINE1);
                    localStorage.setItem('line1', prodJSON.LINE1);
                }

                if(prodJSON.LINE2)
                {
                    sessionStorage.setItem('line2', prodJSON.LINE2);
                    localStorage.setItem('line2', prodJSON.LINE2);
                }

                if(prodJSON.DATE)
                {
                    sessionStorage.setItem('date', prodJSON.DATE);
                    localStorage.setItem('date', prodJSON.DATE);
                }

                if(prodJSON.LOCATION)
                {
                    sessionStorage.setItem('location', prodJSON.LOCATION);
                    localStorage.setItem('location', prodJSON.LOCATION);
                }

                if(prodJSON.TIME)
                {
                    sessionStorage.setItem('time', prodJSON.TIME);
                    localStorage.setItem('time', prodJSON.TIME);
                }
            }
            else if((prodJSON.PRODUCT_TYPE && prodJSON.PRODUCT_TYPE.includes('JOURNEY')))
            {
                if(prodJSON.LINE1)
                {
                    sessionStorage.setItem('journeymap-line1', prodJSON.LINE1);
                    localStorage.setItem('journeymap-line1', prodJSON.LINE1);
                }

                if(prodJSON.LINE2)
                {
                    sessionStorage.setItem('journeymap-line2', prodJSON.LINE2);
                    localStorage.setItem('journeymap-line2', prodJSON.LINE2);
                }

                if(prodJSON.TITLE)
                {
                    sessionStorage.setItem('journeymap-title', prodJSON.TITLE);
                    localStorage.setItem('journeymap-title', prodJSON.TITLE);
                }

                if(prodJSON.TEXT_ALIGNMENT)
                {
                    sessionStorage.setItem('journeymap-text-alignment', prodJSON.TEXT_ALIGNMENT);
                    localStorage.setItem('journeymap-text-alignment', prodJSON.TEXT_ALIGNMENT);
                }
            }
        }
    }
}

function isValidEmail(email)
{
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}


function isValidLocationObject(location)
{
    let retval = false;

    try
    {
        if(location)
        {
            let locationJSON = typeof (location) == 'string' ? JSON.parse(location) : location;

            retval = locationJSON && locationJSON.country && ( (locationJSON.country == 'United States' && locationJSON.state) || locationJSON.country != 'United States' )  && locationJSON.lat && locationJSON.lng && locationJSON.city ? true : false;
        }

    }
    catch (e)
    {
        console.log(e);
    }


    return retval;
}

function scrollToAnchor(anchorId)
{
    try
    {
        console.log('Scrolling to: ' + anchorId);
        var aTag = $("a[id='"+ anchorId +"']");
        var headerHeight = $('#header-container').outerHeight() + 40;

        if(aTag)
        {
            let stateCheck = setInterval(() => {
                if (document.readyState === 'complete') {
                    clearInterval(stateCheck);
                    $('html,body').animate({scrollTop: aTag.offset().top - headerHeight},'slow');
                }
                console.log('waiting to scroll');
            }, 500);
        }
    }
    catch (e)
    {
        console.log(e);
    }
}

function setLocationFields(currentAddress)
{
    if(isValidLocationObject(currentAddress) )
    {
        if (currentAddress.country.toUpperCase() == 'UNITED STATES') {
            $('.preview_star-map_state-country').html(currentAddress.state);
        } else {
            $('.preview_star-map_state-country').html(currentAddress.country);
        }

        $('.preview_star-map_city').html(currentAddress.city);
        $('.preview_star-map_lat').html(currentAddress.lat);
        $('#personalized__product-options__star-maps__latitude').val(currentAddress.lat);

        $('.preview_star-map_long').html(currentAddress.lng);
        $('#personalized__product-options__star-maps__longitude').val(currentAddress.lng);


        if (currentAddress.country.toUpperCase() == 'UNITED STATES') {
            $('#personalized__product-options__star-maps__location').val(currentAddress.city + ", " + currentAddress.state);

        } else {
            $('#personalized__product-options__star-maps__location').val(currentAddress.city + ", " + currentAddress.country);
        }
    }
}

function isFacebookApp() {
    var ua = navigator.userAgent || navigator.vendor || window.opera;
    return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
}



function saveField(inputName, value, _learnq = null)
{
    try
    {
        value = value == '' || value=='null' ? null : value;
        localStorage.setItem(inputName, value);
        sessionStorage.setItem(inputName, value);

        persistProductDetails(_learnq);
        // console.log('saving '+ inputName + ' with value: ' + (value == null? 'null' : value));
    }
    catch (e) {
        console.log('Persist Error: ' + e.message);
    }
}

function updatePersistTextByClass(_learnq, className, inputElement, persistAs = null)
{
    const text = inputElement;
    const elements = document.querySelectorAll(className);

    if(persistAs!=null)
    {
        saveField(persistAs, inputElement, _learnq);
    }

    var count = 0;
    Array.from(elements).forEach((element, index) => {
        const defaultText = element.getAttribute('default-text');

        if ((text == "" || text == null) && (defaultText != "" && defaultText != null)) {
            element.innerHTML = defaultText;
        } else {
            element.innerHTML = text;
        }
    });
}

function updateTextByClass(className, inputElement, persistAs = null)
{
    const text = inputElement;
    const elements = document.querySelectorAll(className);

    if(persistAs!=null)
    {
        saveField(persistAs, inputElement);
    }

    var count = 0;
    Array.from(elements).forEach((element, index) => {
        const defaultText = element.getAttribute('default-text');

        if ((text == "" || text == null) && (defaultText != "" && defaultText != null)) {
            element.innerHTML = defaultText;
        } else {
            element.innerHTML = text;
        }
    });
}

function convertToOrdinalDate(d) {
    var months = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    var e = new Date(d);

    var retval = months[e.getUTCMonth()] + ' ' + addOrd(e.getUTCDate()) + ' ' + e.getUTCFullYear();
    return  retval;
}

function tConvert (time) {

    console.log('time ' + time);
    // Check correct time format and split into components
    time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
        time = time.slice (1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }

    var retval = time.join ('');
    // alert(retval);

    return retval; // return adjusted time or original string
}
function formatDateAsMMDDYYYY(inputDate) {
    dArr = inputDate.split("-");  // ex input "2010-01-18"
    return dArr[1]+ "/" +dArr[2]+ "/" +dArr[0];
}



function toggleVisibility(element, isVisible)
{
    var localElement = document.getElementById(element.id);
    if (localElement!=null)
    {
        localElement.style.display = isVisible ? 'block' : 'none';
    }
}

function syncSizesMin(element1ClassName, element2ClassName)
{
    var line1Scale = 0;
    var line2Scale = 0;

    var line1Elements = $(element1ClassName);
    var line2Elements = $(element2ClassName);

    if(line1Elements!=null && line2Elements!=null && line1Elements.length>0 && line2Elements.length>0 && line1Elements.length == line2Elements.length)
    {
        for(var count=0; count<line1Elements.length; count++)
        {
            var currentLine1Element = line1Elements[count];
            var currentLine2Element = line2Elements[count];

            var line1FontSize = parseFloat(currentLine1Element.style.fontSize);
            var line2FontSize = parseFloat(currentLine2Element.style.fontSize);

            if(line1FontSize > line2FontSize)
            {
                currentLine1Element.style.fontSize = currentLine2Element.style.fontSize;
            }
            else if (line2FontSize > line1FontSize)
            {
                currentLine2Element.style.fontSize = currentLine1Element.style.fontSize;
            }
        }
    }
}

function toggleVisibilityClass(elementId, isVisible)
{

    var localElement = $('#'+elementId);
    if (localElement!=null)
    {
        if(isVisible)
        {
            localElement.removeClass('invisible-class');
            localElement.addClass('visible-class');
        }
        else
        {
            localElement.addClass('invisible-class');
            localElement.removeClass('visible-class');
        }

    }
}


function toggleVisibilityByClassName(className, isVisible)
{

    var els = document.getElementsByClassName(className);

    Array.prototype.forEach.call(els, function(localElement) {
        // Do stuff here

        if(localElement!=null)
        {
            localElement.style.display = isVisible ? 'block' : 'none';
        }
    });

}

function decodeHTML(encodedString) {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = encodedString;
    return textArea.value;
}

function initCountdown(deadline)
{

    var x = setInterval(function() {

        var now = new Date().getTime();
        var t = deadline - now;
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        var hours = Math.floor((t%(1000 * 60 * 60 * 24))/(1000 * 60 * 60));
        var minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((t % (1000 * 60)) / 1000);
        document.getElementById("day").innerHTML =days ;
        document.getElementById("hour").innerHTML =hours;
        document.getElementById("minute").innerHTML = minutes;
        document.getElementById("second").innerHTML =seconds;
        if (t < 0) {
            clearInterval(x);
            document.getElementById("demo").innerHTML = "TIME UP";
            document.getElementById("day").innerHTML ='0';
            document.getElementById("hour").innerHTML ='0';
            document.getElementById("minute").innerHTML ='0' ;
            document.getElementById("second").innerHTML = '0'; }
    }, 1000);
}

function showPleaseWait() {

    if (document.querySelector("#pleaseWaitDialog") == null) {
        var modalLoading = '<div class="modal" id="pleaseWaitDialog" data-backdrop="static" data-keyboard="false" role="dialog">\
            <div class="modal-dialog">\
                <div class="modal-content">\
                    <div class="modal-header">\
                        <h4 class="modal-title">Please wait...</h4>\
                    </div>\
                    <div class="modal-body">\
                        <div class="progress">\
                          <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar"\
                          aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width:100%; height: 40px">\
                          </div>\
                        </div>\
                    </div>\
                </div>\
            </div>\
        </div>';
        $(document.body).append(modalLoading);
    }

    $("#pleaseWaitDialog").modal("show");
}

/**
 * Hides "Please wait" overlay. See function showPleaseWait().
 */
function hidePleaseWait() {
    $("#pleaseWaitDialog").modal("hide");
}

function redirectToUrl(url)
{
    window.location.href=url;
}

function addHoursToDate(numOfHours, date = new Date()) {
    date.setTime(date.getTime() + numOfHours * 60 * 60 * 1000);

    return date;
}

function ISODateString(d){
    function pad(n){return n<10 ? '0'+n : n}
    return d.getUTCFullYear()+'-'
        + pad(d.getUTCMonth()+1)+'-'
        + pad(d.getUTCDate())+'T'
        + pad(d.getUTCHours())+':'
        + pad(d.getUTCMinutes())+':'
        + pad(d.getUTCSeconds())+'Z'
}

function getDateInUTC(hoursFromNow)
{
    return ISODateString(addHoursToDate(hoursFromNow));
}

function getZodiacFromVariant(variant)
{
    var retval = null;
    var variantToUpper = variant ? variant.toUpperCase() : null;

    if(variantToUpper)
    {
        if(variantToUpper.includes('ARIES'))
        {
            retval = 'ARIES';
        }
        else if (variantToUpper.includes('TAURUS'))
        {
            retval = 'TAURUS';
        }
        else if (variantToUpper.includes('GEMINI'))
        {
            retval = 'GEMINI';
        }
        else if (variantToUpper.includes('CANCER'))
        {
            retval = 'CANCER';
        }
        else if (variantToUpper.includes('LEO'))
        {
            retval = 'LEO';
        }
        else if (variantToUpper.includes('VIRGO'))
        {
            retval = 'VIRGO';
        }
        else if (variantToUpper.includes('LIBRA'))
        {
            retval = 'LIBRA';
        }
        else if (variantToUpper.includes('SCORPIO'))
        {
            retval = 'SCORPIO';
        }
        else if (variantToUpper.includes('SAGITTARIUS'))
        {
            retval = 'SAGITTARIUS';
        }
        else if (variantToUpper.includes('CAPRICORN'))
        {
            retval = 'CAPRICORN';
        }
        else if (variantToUpper.includes('AQUARIUS'))
        {
            retval = 'AQUARIUS';
        }
        else if (variantToUpper.includes('PISCES'))
        {
            retval = 'PISCES';
        }
    }

    return retval;
}

function emailChangedHandler(email, isCreateProfile, _learnq)
{
    if(isCreateProfile)
    {
        if(isValidEmail(email))
        {
            setContactInfo(email, _learnq );
        }
    }
    else
    {
        saveField('email', email, _learnq);
    }
}

function disableAutoComplete() {
    var isChromium = window.chrome;
    var winNav = window.navigator;
    var vendorName = winNav.vendor;
    var isOpera = typeof window.opr !== "undefined";
    var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
    var isIOSChrome = winNav.userAgent.match("CriOS");


    var retval = "off";
    if (isIOSChrome || (isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false))
    {
        retval = "chrome-off";
    }

    return retval;
}

function setContactInfo(email, _learnq )
{
    try
    {
        if(_learnq && _learnq.isIdentified && !_learnq.isIdentified())
        {
            _learnq.push(['identify', {
                '$email' : email
            }]);
        }

        localStorage.setItem('email', email);
        sessionStorage.setItem('email', email);
    }
    catch (e)
    {
        console.log(e);
    }

}


function setCouponDetailsByExpirationHours(couponExpirationHours, couponDiscountPercentage, couponOfferId = null, _learnq)
{
    try
    {
        let couponExpirationTime = getCouponExpirationTime() && new Date(getCouponExpirationTime()).getTime()>new Date().getTime() ? getCouponExpirationTime() : getDateInUTC(couponExpirationHours);

        if(couponExpirationHours!=null)
        {
            setCouponExpirationTime(couponExpirationTime)
        }

        if(couponDiscountPercentage!=null)
        {
            setCouponDiscountPercentage(couponDiscountPercentage);
        }

        if(couponOfferId)
        {
            setCouponOfferId(couponOfferId);

            if(_learnq) {
                _learnq.push(['identify', {
                    'CouponExpirationTime': couponExpirationTime,
                    'CouponExpirationTime64': btoa(couponExpirationTime),
                    'DiscountPercentage': couponDiscountPercentage,
                    'CouponOfferId': couponOfferId
                }]);
            }
        }
        else
        {
            if(_learnq) {
                _learnq.push(['identify', {
                    'CouponExpirationTime': couponExpirationTime,
                    'CouponExpirationTime64': btoa(couponExpirationTime),
                    'DiscountPercentage': couponDiscountPercentage
                }]);
            }
        }

    }
    catch (e) {
        console.log('Set Coupon Expiration Error: ' + e.message);
    }
}

function setCouponDetailsByExpirationDateTime(couponExpirationString, couponDiscountPercentage, couponOfferId = null, _learnq)
{
    try
    {
        if(couponExpirationString && (new Date(couponExpirationString) - new Date()) > 0)
        {
            if(couponExpirationString!=null)
            {
                setCouponExpirationTime(couponExpirationString)
            }

            if(couponDiscountPercentage!=null)
            {
                setCouponDiscountPercentage(couponDiscountPercentage);
            }

            if(couponOfferId)
            {
                setCouponOfferId(couponOfferId);

                if(_learnq)
                {
                    _learnq.push(['identify', {
                        'CouponExpirationTime' : couponExpirationString,
                        'CouponExpirationTime64' : btoa(couponExpirationString),
                        'DiscountPercentage' : couponDiscountPercentage,
                        'CouponOfferId' : couponOfferId
                    }]);
                }

            }
            else
            {
                if(_learnq)
                {
                    _learnq.push(['identify', {
                        'CouponExpirationTime' : couponExpirationString,
                        'CouponExpirationTime64' : btoa(couponExpirationString),
                        'DiscountPercentage' : couponDiscountPercentage
                    }]);
                }
            }
        }

    }
    catch (e) {
        console.log('Set Coupon Expiration Error: ' + e.message);
    }
}

function loadKVForm(name)
{

    try
    {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', name]);
    }
    catch (e) {
        console.log(e);
    }

}

function persistProductDetails(_learnq)
{
    let prodsAsJSON = serializeProducts(true);
    let currentURL = window.location.toString();

    try
    {
        if(currentURL.includes('/products/'))
        {
            if(currentURL.includes('star-map') && prodsAsJSON)
            {
                if(_learnq!=null)
                {
                    _learnq.push(['identify', {
                        'PRODUCT_TYPE' : 'STAR-MAP',
                        'PRODUCT_VARIANT_ID': prodsAsJSON.VARIANT_ID,
                        'PRODUCT_DATA' : prodsAsJSON,
                        'PRODUCT_URL' : currentURL,
                        'PRODUCT_DATA_64' : btoa(JSON.stringify(prodsAsJSON)),
                        'PRODUCT_DATE' :  prodsAsJSON.DATE
                    }]);
                }
            }
            else if(currentURL.includes('journey-map') && prodsAsJSON)
            {
                if(_learnq!=null)
                {
                    _learnq.push(['identify', {
                        'PRODUCT_TYPE' : 'JOURNEY-MAP',
                        'PRODUCT_VARIANT_ID': prodsAsJSON.VARIANT_ID,
                        'PRODUCT_DATA' : prodsAsJSON,
                        'PRODUCT_URL' : currentURL,
                        'PRODUCT_DATA_64' : btoa(JSON.stringify(prodsAsJSON)),
                    }]);
                }
            }
            else if(currentURL.includes('zodiac') && prodsAsJSON)
            {
                if(_learnq!=null)
                {
                    _learnq.push(['identify', {
                        'PRODUCT_TYPE' : 'ZODIAC-CHART',
                        'PRODUCT_VARIANT_ID': prodsAsJSON.VARIANT_ID,
                        'PRODUCT_DATA' : prodsAsJSON,
                        'PRODUCT_URL' : currentURL,
                        'PRODUCT_DATA_64' : btoa(JSON.stringify(prodsAsJSON)),
                    }]);
                }
            }
        }


    }
    catch (e){
        console.log(e);
    }
}

function getShopPayMessage()
{
    var svg = '';
}

function getGUID() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
}

function sessionId()
{
    return Math.floor(Math.random()*90000) + 10000;
}

function processStrikeThrough(showDiscountMessage = false)
{
    try
    {
        let url = window.location.toString();
        if(isCouponActive())
        {
            let couponPercentage = getSessionCouponDiscountPercentage();

            if(url.includes('/products/') && !url.includes('gift'))
            {
                let productPrice = $('#ProductPrice');

                if(productPrice!=null && productPrice.length>0)
                {
                    let isNotStriked = !productPrice.html().includes('line-through');

                    if(isNotStriked)
                    {
                        let oldProductPrice = parseFloat(productPrice.text().match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]);
                        let newProductPrice = oldProductPrice * (100 - couponPercentage) * .01;

                         if(showDiscountMessage)
                        {
                            productPrice.html('<span style="text-decoration:line-through; id="ProductPriceOriginal" text-decoration-thickness: 2px; text-decoration-color:red;"><span style="color:black;">'+productPrice.html()+'</span></span><span style="color:red;">&nbsp;' + formatAsDollar(newProductPrice) + '</span><div class="productDiscountMessage">'+couponPercentage + '% discount applied (expires soon)</div>') ;
                        }
                        else
                        {
                            productPrice.html('<span style="text-decoration:line-through; id="ProductPriceStrikeThrough" text-decoration-thickness: 2px; text-decoration-color:red;"><span style="color:black;">'+productPrice.html()+'</span></span><span style="color:red;">&nbsp;' + formatAsDollar(newProductPrice)+ '</span>') ;
                        }

                        $('.bnpl-top').hide();
                    }
                }
            }
            else if(url.includes('/collections/'))
            {
                $('.ProductPrice').each(function(i, productPrice)
                {
                    let isNotStriked = !productPrice.innerHTML.includes('line-through');

                    if(isNotStriked) {

                        // if(!(productPrice && productPrice.parentElement && productPrice.parentElement.parentElement && productPrice.parentElement.parentElement.querySelector('.grid-product__title') && productPrice.parentElement.parentElement.querySelector('.grid-product__title').innerHTML &&
                        //     productPrice.parentElement.parentElement.parentElement.querySelector('.grid-product__title').innerHTML.toUpperCase().includes('GIFT')))

                            let oldProductPrice = parseFloat(productPrice.innerHTML.match(/-?(?:\d+(?:\.\d*)?|\.\d+)/)[0]);
                            let newProductPrice = oldProductPrice * (100 - couponPercentage) * .01;
                        if(oldProductPrice>50 || oldProductPrice<50)
                        {
                            if (showDiscountMessage) {
//                            productPrice.innerHTML = '<span style="text-decoration:line-through; text-decoration-thickness: 1px; text-decoration-color:red;"><span style="color:black;">' + productPrice.innerHTML + '</span></span><span style="color:red;">&nbsp;' + formatAsDollar(newProductPrice) + '+</span><div class="productDiscountMessage">' + couponPercentage + '% discount applied</div>';
                                productPrice.innerHTML = '<span style="text-decoration:line-through; text-decoration-thickness: 1px; text-decoration-color:red;"><span style="color:black;">' + productPrice.innerHTML + '</span></span><span style="color:red;">&nbsp;' + formatAsDollar(newProductPrice) + '+</span> &nbsp;<span class="productDiscountMessage">' + couponPercentage + '% off</span>';

                            } else {
                                productPrice.innerHTML = '<span style="text-decoration:line-through; text-decoration-thickness: 1px; text-decoration-color:red;"><span style="color:black;">' + productPrice.innerHTML + '</span></span><span style="color:red;">&nbsp;' + formatAsDollar(newProductPrice) + '+</span>';
                            }
                        }
                    }
                });
            }
        }
    }
    catch (e)
    {
        console.log(e);
    }

}

function serializeProducts(asJSON = false)
{
    var retval = null;
    try
    {
        let currentURL = window.location.toString();
        if(currentURL.includes('/products/'))
        {
            let variantId = document.getElementsByName("id")["0"].value;

            if (currentURL.includes('star-map'))
            {
                let id = $('#personalized__product-options__id');
                let line1 = $('#personalized__product-options__star-maps__line-1');
                let line2 = $('#personalized__product-options__star-maps__line-2');
                let loc = $('#personalized__product-options__star-maps__location_json');
                let date = $('#personalized__product-options__star-maps__date');
                let time = $('#personalized__product-options__star-maps__time');
                let email = $('#personalized__product-options__star-maps__email');
                retval =  {
                    'ID': id.val(),
                    'VARIANT_ID': variantId,
                    'PRODUCT_TYPE': 'STAR-MAP',
                    'LINE1' : line1.val(),
                    'LINE2' : line2.val(),
                    'LOCATION' : loc.val(),
                    'DATE' : date.val(),
                    'TIME' : time.val(),
                    'PRODUCT_URL' : currentURL,
                    'EMAIL' : email.val()
                };

                retval = asJSON? retval : JSON.stringify(retval);
            }
            else if(currentURL.includes('journey-map'))
            {
                let id = $('#personalized__product-options__id');
                let title = $('#personalized__product-options__journey-maps__title');
                let line1 = $('#personalized__product-options__journey-maps__line-1');
                let line2 = $('#personalized__product-options__journey-maps__line-2');
                let email = $('#personalized__product-options__journey-maps__email');
                let textAlignment = $('#personalized__product-options__journey-maps__text-alignment');
                let specialRequests = $('#personalized__product-options__journey-maps__special-requests');

                retval =  {
                    'ID': id.val(),
                    'VARIANT_ID': variantId,
                    'PRODUCT_TYPE': 'JOURNEY-MAP',
                    'TITLE' : title.val(),
                    'LINE1' : line1.val(),
                    'LINE2' : line2.val(),
                    'TEXT_ALIGNMENT': textAlignment.val(),
                    'SPECIAL_REQUESTS' : specialRequests.val(),
                    'PRODUCT_URL' : currentURL,
                    'EMAIL' : email.val()
                };

                retval = asJSON? retval : JSON.stringify(retval);
            }
            else if(currentURL.includes('zodiac'))
            {
                let id = $('#personalized__product-options__id');
                let primaryText = $('#personalized__product-options__zodiac-chart__primary-text');
                let secondaryText = $('#personalized__product-options__zodiac-chart__secondary-text');
                let email = $('#personalized__product-options__zodiac-chart__email');

                retval =  {
                    'ID': id.val(),
                    'VARIANT_ID': variantId,
                    'PRODUCT_TYPE': 'ZODIAC-CHART',
                    'PRIMARY_TEXT' : primaryText.val(),
                    'SECONDARY_TEXT' : secondaryText.val(),
                    'PRODUCT_URL' : currentURL,
                    'EMAIL' : email.val()
                };

                retval = asJSON? retval : JSON.stringify(retval);
            }
        }
    }
    catch (e)
    {
        console.log(e)
    }

    return retval;
}

function formatAsDollar(stringToFormat)
{
    // Create our number formatter.
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(stringToFormat);
}

function getCouponExpirationTime()
{
    return sessionStorage.getItem('couponExpirationTime') || localStorage.getItem('couponExpirationTime');
}

function setCouponExpirationTime(couponExpirationTime)
{
    localStorage.setItem('couponExpirationTime', couponExpirationTime);
    sessionStorage.setItem('couponExpirationTime', couponExpirationTime);
}

function setCouponCode(couponExpirationTime)
{
    localStorage.setItem('couponCode', couponExpirationTime);
    sessionStorage.setItem('couponCode', couponExpirationTime);
}

function getCouponDiscountPercentage()
{
    return sessionStorage.getItem('couponDiscountPercentage') || localStorage.getItem('couponDiscountPercentage');
}

function getCouponCode()
{
    return sessionStorage.getItem('couponCode') || localStorage.getItem('couponCode');
}

function getCouponOfferId()
{
    return sessionStorage.getItem('couponOfferId') || localStorage.getItem('couponOfferId');
}

function setCouponDiscountPercentage(couponDiscountPercentage)
{
    localStorage.setItem('couponDiscountPercentage', couponDiscountPercentage);
    sessionStorage.setItem('couponDiscountPercentage', couponDiscountPercentage);
}

function setCouponOfferId(offerId)
{
    localStorage.setItem('couponOfferId', offerId);
    sessionStorage.setItem('couponOfferId', offerId);
}

function clearCouponSessionData()
{
    try
    {
        localStorage.removeItem('couponExpirationTime');
        localStorage.removeItem('couponDiscountPercentage');
        localStorage.removeItem('couponOfferId');
        localStorage.removeItem('couponCode');


        sessionStorage.removeItem('couponExpirationTime');
        sessionStorage.removeItem('couponDiscountPercentage');
        sessionStorage.removeItem('couponOfferId');
        sessionStorage.removeItem('couponCode');
    }
    catch (e)
    {
        console.log(e);
    }
}

function isCouponActive()
{
    var retval = false;
    var couponExpirationTime = getCouponExpirationTime();
    var couponDiscountPercentage = getCouponDiscountPercentage();

    if(couponExpirationTime && couponDiscountPercentage)
    {
        var currentEpoch = new Date().getTime();
        var couponEpoch = new Date(couponExpirationTime).getTime();

        retval = couponEpoch>currentEpoch;
    }

    return retval;
}

function convertMillisecondsToHours(val)
{
    if(val && val>0)
    {
        return val/(60*60*1000);
    }
    else
    {
        return 0;
    }
}

function getSessionCouponDiscountPercentage()
{
    return sessionStorage.getItem('couponDiscountPercentage') || localStorage.getItem('couponDiscountPercentage');
}

function getSessionEmail()
{
    return sessionStorage.getItem('email') || localStorage.getItem('email');
}

function updateCouponAnnouncement(couponDiscountPercentage = getSessionCouponDiscountPercentage())
{
    var announcementBar = $('#announcement-bar');
    var couponExpirationTime = getCouponExpirationTime();
    var couponCode = getCouponCode();

    if(isCouponActive())
    {

        if(couponCode)
        {
            announcementBar.html('<p class="announcement-bar__message" style="width:100%; font-size:9.5pt;"><b> Your '+ couponDiscountPercentage +'% off code ('+ couponCode +') expires in:</b><br/><img class="announcementTimer" " src="https://i.countdownmail.com/1z06xd.gif?end_date_time='+ couponExpirationTime +'" border="0" alt=""/></p>');

        }
        else
        {
            announcementBar.html('<p class="announcement-bar__message" style="width:100%; font-size:9.5pt;"><b>'+ couponDiscountPercentage +'% off activated! Your code expires in:</b><br/><img class="announcementTimer" " src="https://i.countdownmail.com/1z06xd.gif?end_date_time='+ couponExpirationTime +'" border="0" alt=""/></p>');
        }
        headerSize(20);
    }
}

function changeInputValue(id,value)
{
    const el = document.getElementById(id);
    el.value = value;
    el.dispatchEvent(new Event('input', { 'bubbles': true }));
}

